var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n     "+_vm._s(_vm.params.data.subject)+"\n                "),(_vm.params.data.thread_count !== 0)?_c('span',[_vm._v("\n                  ("+_vm._s(_vm.params.data.thread_count)+")\n                ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }